module.exports = __webpack_public_path__ + "img/daily-report.0a2c293c.png";